export enum InventoryCountForm {
  StartDateStartTime = 'vn7J',
  EndDateEndTime = 'Hc12',
  SheetViewSetting = 'eIx0',
  ExtendedValue = '+cxW',
  CountedValue = '0QWv',
  Variance = 'KhI3',
  SetCountUnit = 'YAesT',
  DefaultTransferUnit = 'Bx5S',
  DefaultOrderingUnit = 't2wn',
  VarianceCost = 'PgQa',
  VarianceQuantity = 'B1eT',
  Group = 'NMoO',
  ClearCount = 'dUIz',
  WriteZerosToBlankCounts = 'r39W',
  SaveCount = 'YZwG',
  CompleteCount = 'kAAG',
  inventorycounts = 'V/wx',
  SubmitSiteCount = 'cEUh',
  ItemNameHasBeenSubmitted = 'eMj4',
  DateAndTime = '4A48',
  inventoryCount = 'IEOw',

  EnterInventoryCountName = 'npNc',
  YourInventoryCountDetailsFormHasErrors = 'fjq+',
}
